import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetAppConfigByFieldOutput } from './GetAppConfigByFieldOutput';

export class GetAppConfigByFieldService extends HttpServiceBase {

  handle = (field: string): Promise<Result<GetAppConfigByFieldOutput> | null> => {
    const promise = this.http.get<Result<GetAppConfigByFieldOutput>>(`${this.baseUrlSislogApi}/v2/app-config/by-field?field=${field}`);
    return promise;
  }
}